// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, saveCard, keycardStatus } from '../../../constants/globalConstants'
import { getPermitDataList, getPermitQR, CancelPermit, PermitRenewData, AddServicePermitAction, CancelPermitRenew, keycardReplacementRequestAction, keycardReplacementDetails } from '../../../redux/actions/PermitListAction'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
// import { staticStrings } from '../../../constants/staticStrings'
import { errorMessage } from '../../../constants/errorMessage'
import moment from 'moment'
import { handlingPermitServiceCriteria, perkingParkingTimeAccount, isPermissionExist, sortPortalPermissionByKey, encryptionHandler, isLoggedIn, validExpiryDate, shouldShowVehicleColumn, isActivePermit, employerDetailsSection, validatorRule, handleValidator, excludeKeysFromValidator } from '../../../utils/helper'
import AddCardPaymentModal from '../../../components/global/addCardPaymentModal'
import { getCardDataList } from '../../../redux/actions/cardDetailsAction'
import ModalTerm from '../../../pages/responsiveReservation/termCond'
import ConfermationModal from '../../../components/global/ConfermationModal'
import PassWalletButtons from '../../../components/global/PassWalletButtons'
import { APICONFIG } from '../../../redux/config/apiConfig'
import useMobileView from '../../../Hooks/useMobileView'
import ConfirmationModal from '../../../components/global/modal/ConfirmationModal'
import TCAcceptanceSection from '../../../Global/TCAcceptanceSection'
import SimpleReactValidator from 'simple-react-validator'
// import permitTypeLogo from '../../../assets/img/permit_type_account.png'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PermitAccount(props) {
    const { dispatch, loader, notify, partnerDetails } = props

    const validator = useRef(new SimpleReactValidator({
        element: message => <span className="form-text text-danger h-40">{message}</span>,
        validators: validatorRule
    }))
    const [, forceUpdate] = useState()

    const [permitListData, setPermitListData] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    const [downloadQR, setDownloadQR] = useState(false)
    const [displayError, setDisplayError] = useState('')
    const [accessPermissions, setAccessPermissions] = useState('')
    const [permit_no, setPermitNo] = useState(EMPTY_OBJECT)
    const [isModalOpen, setModal] = useState(false)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')

    //new

    const [expiry, setExpiry] = useState()

    const [card, setCard] = useState()

    const [payload, setPayload] = useState(saveCard)

    const [isLoading, setIsLoading] = useState(false)

    const [errorMessagePay, setErrorMessagePay] = useState('')

    const [cardList, setCardList] = useState(EMPTY_ARRAY)

    const [isCardFormVisible, setCardFormVisible] = useState(false)

    const [error, setError] = useState(false)

    const [isConsent, setIsConsent] = useState(true)

    const [showTerm, setTermShow] = useState(false)
    const [displayCheckIn, setDisplayCheckIn] = useState(false)
    const [cancelModal, setCancelModal] = useState(false)
    const [permitdata, setPermitData] = useState(EMPTY_OBJECT)
    const [isCancelLoading, setIsCancelLoading] = useState(false)
    const [buyoutType, setBuyoutType] = useState(false)
    const [showKeyCardChangeModal, setShowKeyCardChangeModal] = useState(false)
    const [keyCardData, setKeyCardData] = useState({
        userAcknowledge: false,
        tc_acceptance_signature: '',
        tc_acceptance_date: new Date(),
        facility_id: ''
    })
    const [formError, setFormError] = useState(false)

    // EOS-973
    const [isFiservGateway, setIsFiservGateway] = useState(false)
    const tokenRef = useRef(null)
    const [cardToken, setCardToken] = useState('')
    const [iframeErrorMsg, setIframeErrorMsg] = useState('')
    const [facilityDetails, setFacilityDetails] = useState([])
    // EOS-973

    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
    const isMobile = useMobileView()
    const keyCardModalRef = useRef(null)


    let dateDisplayFormat = 'DD MMM, YYYY'

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    const getPermitList = () => {
        dispatch(getPermitDataList()).then((res) => {
            if (res?.data && res?.data != null) {
                // const userData = localStorage.getItem('userData')
                // const userDetails = JSON.parse(userData)
                // setUserData(userDetails)
                setPermitListData(res?.data)
                setIsConsent(res?.data?.user_consent == '1' ? true : false)
            } else {
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }

    useEffect(() => {
        // setTimeout(
        getPermitList()
        //     if (res) {
        //         // const userData = localStorage.getItem('userData')
        //         // const userDetails = JSON.parse(userData)
        //         // setUserData(userDetails)
        //         setPermitListData(res)
        //     }
        // })
        // , 500)

        if (isLoggedIn()) {
            setCardFormVisible(false)
            // const facility_id = partnerDetails?.facilities?.[0]?.id
            dispatch(getCardDataList()).then((res) => {
                if (res?.data) {
                    setCardList(res?.data?.payments)
                    // setIsLoading(false)
                }
            }).catch(() => {
                // setIsLoading(false)
            })
        } else {
            setCardFormVisible(true)
        }

    }, [EMPTY_ARRAY])

    const handleModalTerm = () => {
        setTermShow(!showTerm)
    }

    const handlePaymentModalOpen = (item) => {
        setPermitNo(item)
        setModal(true)
        setPayload({ ...payload, payable_permit_amount: item?.permit_final_amount })
    }

    useEffect(() => {
        // Check if this is Fiserv payment gateway
        const paymentTypeId = permit_no?.facility?.facility_payment_details?.facility_payment_type_id        
        setIsFiservGateway(paymentTypeId == '3')
        setFacilityDetails(permit_no?.facility)
    },[permit_no])

    const handleCardSelectChange = (e) => {

        const { value } = e.target

        const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)

        payload['payment_profile_id'] = selectedCard[0]?.payment_profile_id

        setPayload({ ...payload })

    }

    const handleExpiryChange = (value) => {

        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            setCardExpiryMessage('Enter a valid expire date')
        } else {
            setCardExpiryMessage('')
            setExpiry(value?.trim())
            payload['expiration_date'] = value?.trim()
            setPayload({ ...payload })
        }

    }



    // const handleExpiryChange = (value) => {

    //     setExpiry(value?.trim())

    //     payload['expiration_date'] = value?.trim()

    //     setPayload({ ...payload })

    // }



    const handleCardChange = (value) => {

        setCard(value?.trim())

        payload['card_number'] = value?.trim()

        setPayload({ ...payload })

    }

    const hanndleCancel = () => {
        setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })
        setCard('')
        setExpiry('')
        setModal(false)
    }

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target
        setPayload({ ...payload, [name]: value })

    }




    const handleSubmit = () => {

        setError(true)

        setIsLoading(true)

        if (Object.values(payload)?.length > 0 && payload?.payment_profile_id || (payload?.name_on_card && payload?.card_number && payload?.card_number?.length === 16 && payload?.expiration_date && payload?.security_code) || (cardToken && cardToken?.token && !iframeErrorMsg)) {

            payload.zip_code = payload?.zip_code_on_card ? payload?.zip_code_on_card : ''

            let finalPayload

            setErrorMessagePay('')

            if (!payload?.payment_profile_id || payload?.payment_profile_id == '') {
                let nonce
                if(isFiservGateway){
                    const tokenizedCard = {
                        name_on_card: '',
                        card_number: cardToken?.message || cardToken?.token,
                        expiration_date: cardToken?.expiry || '',
                        security_code: cardToken?.cvv || '',
                        zip_code: ''
                    }
                    nonce = encryptionHandler(tokenizedCard)
                }else{
                    nonce = encryptionHandler(payload)
                }
                finalPayload = {

                    'nonce': nonce,

                    'permit_number': permit_no?.account_number,

                    'user_consent': 1,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            } else {

                finalPayload = {

                    'payment_profile_id': payload?.payment_profile_id,

                    'permit_number': permit_no?.account_number,

                    'user_consent': 0,

                    'payable_permit_amount': payload?.payable_permit_amount ? payload?.payable_permit_amount : '',

                }

            }

            dispatch(PermitRenewData(finalPayload)).then((res) => {

                if (res && res?.data !== null) {

                    notify('success', 'Payment is made successfully')

                    setPayload({ card_number: '', expiration_date: '', payment_profile_id: '' })

                    setCard('')

                    setExpiry('')

                    setModal(false)

                    setError(false)

                    setIsLoading(false)

                    dispatch(getPermitDataList()).then((res) => {

                        if (res?.data && res?.data != null) {

                            // const userData = localStorage.getItem('userData')

                            // const userDetails = JSON.parse(userData)

                            // setUserData(userDetails)

                            setPermitListData(res?.data)

                        } else {

                            setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)

                        }

                    }).catch((err) => {

                        setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        setIsLoading(false)
                    })

                } else if (res?.data === null && res?.errors?.message) {

                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')

                    setIsLoading(false)

                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                    setIsLoading(false)
                }

            }).catch((err) => {

                // setErrorMessage(err?.errors?.message)

                notify('error', err?.errors?.message ? err?.errors?.message : 'Something went wrong, Please try again!')
                setIsLoading(false)
            })

        } else {
            if(iframeErrorMsg && iframeErrorMsg != ''){
                notify('error', iframeErrorMsg)
            }
            setIsLoading(false)

            setErrorMessagePay('')

        }

    }

    const downloadPermitQr = (id, permitAccount) => {
        setDownloadQR(id)
        if (!downloadQR) {
            dispatch(getPermitQR(id, permitAccount)).then((res) => {
                setDownloadQR(false)
                if (res?.status && res?.status == 500) {
                    notify('error', errorMessage?.somethingWentWrong)
                } else {
                    notify('success', 'File Downloaded')
                }
            }).catch((err) => {
                setDownloadQR(false)
                notify('error', err ? err?.message ? err?.message : errorMessage?.somethingWentWrong : errorMessage?.somethingWentWrong)
            })
        }

    }




    const cancelPermit = () => {
        // setPermitListData
        setIsCancelLoading(true)
        dispatch(CancelPermit(permitdata.id)).then((res) => {
            notify('success', res.msg)
            setCancelModal(false)
            setIsCancelLoading(false)
            setBuyoutType(false)
            getPermitList()
        }).catch((err) => {
            console.log(err)
            setIsCancelLoading(false)
        })

    }

    const cancelPermitRenew = (data, index) => {
        // setPermitListData
        if (data?.is_expired == 0 && data?.cancelled_at == null && data?.stop_renew_consent == '0') {
            let resp = permitListData[index].user_consent == '1' ? '0' : '1'
            permitListData[index].user_consent = resp
            setPermitListData(permitListData)
            setIsConsent(!isConsent)
            dispatch(CancelPermitRenew(data.id)).then((res) => {
                notify('success', res.msg)
                // dispatch(getPermitDataList()).then((res) => {
                //     if (res?.data && res?.data != null) {
                //         // const userData = localStorage.getItem('userData')
                //         // const userDetails = JSON.parse(userData)
                //         // setUserData(userDetails)
                //         setPermitListData(res?.data)
                //     } else {
                //         setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                //     }
                // }).catch((err) => {
                //     setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                // })
            }).catch((err) => {
                console.log(err)
            })
        }
    }


    const AddServicePermit = (data, index) => {
        // setPermitListData
        setIsConsent(!isConsent)
        let resp = permitListData[index].permitServiceCarpool == '1' ? '0' : '1'
        permitListData[index].permitServiceCarpool = resp

        //upodate permit service
        //    let permitService= permitListData[index].permitServices
        let carpool = {
            'id': 1,
            // 'partner_id': '363361',
            'permit_service_name': 'Carpool Access',
            // 'permit_service_desc': '',
            // 'open_always': '1',
            // 'permit_service_rate': '0.00',
            // 'is_status': '1',
            // 'created_at': '2024-05-08 15:05:35',
            // 'updated_at': '2024-06-14 00:31:36',
            // 'is_purchase': '1',
            // 'is_negotiable': '0',
            // 'facility_id': null,
            // 'permit_service_criteria_mappings': []
        }
        if (resp == '1') {
            permitListData[index].permitServices.push(carpool)
        } else {
            let carpoolRemove = permitListData[index].permitServices.filter((v) => v.permit_service_name != 'Carpool Access')
            permitListData[index].permitServices = carpoolRemove
        }
        setPermitListData(permitListData)

        const userData = JSON.parse(localStorage.getItem('userData'))
        let payload = {
            permit_service: resp,
            id: data?.id,
            user_id: userData ? userData?.user?.id : '',
        }

        dispatch(AddServicePermitAction(payload)).then((res) => {
            notify('success', res)
            // dispatch(getPermitDataList()).then((res) => {
            //     if (res?.data && res?.data != null) {
            //         setPermitListData(res?.data)
            //     } else {
            //         setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            //     }
            // }).catch((err) => {
            //     setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            // })
        }).catch((err) => {
            console.log(err)
        })

    }

    const handleshowCheckIn = () => {
        setDisplayCheckIn(!displayCheckIn)
    }


    const showPermitModal = (data) => {
        setPermitData(data)
        setBuyoutType(data?.permit_type_name == 'Buyout' ? true : false)
        setCancelModal(true)
    }


    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const DisplayField = (label, value) => {
        return <div className="col-6">
            <label className="floatLabel">{label}</label>
            <div className="inputBox">{value || '-'}</div>
        </div>
    }

    const mobileViewVehicleSection = (v = {}, vehicleListIndex, allVehicle) => {
        const vehicle = v?.vehicle
        return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-2">
            {DisplayField('License Plate', vehicle?.license_plate_number || '-')}
            {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicle?.vehicle_type || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicle.make || vehicle.model)
                ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                : '-' || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicle?.color || '-') : null}
            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicle?.style || '-') : null}

            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicle?.country || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicle?.state_code || '-') : null}
            {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicle?.vehicle_number || '-') : null}
        </div>
    }

    const renderVehicleRow = (v, i, allVehicle) => {
        const vehicle = v?.vehicle || {}
        return (
            <tr key={i}>
                <td className="px-0">{vehicle.license_plate_number || '-'}</td>
                {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
                    <td className="px-0">{vehicle.vehicle_type || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
                    {(vehicle.make || vehicle.model)
                        ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                        : '-'}
                </td> : null}
                {shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
                    <td className="px-0">{vehicle.style || '-'}</td>
                )}
                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
                    <td className="px-0">{vehicle.country || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
                    <td className="px-0">{vehicle.vehicle_number || '-'}</td>
                )}
            </tr>
        )
    }

    const deskTopViewVehicleSection = (item = {}) => {
        return <div className='table-responsive'>
            <table className="table table-borderless table-sm mb-0">
                <thead>
                    <tr>
                        <th className="fw-bold text-muted px-0">License Plate</th>
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'make') && shouldShowVehicleColumn(item?.permit_vehicle, 'model') ? <th className="fw-bold text-muted px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(item?.permit_vehicle, 'vehicle_type') && (
                            <th className="fw-bold px-0 text-muted">Vehicle Type</th>
                        )}
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'color') ? <th className="fw-bold px-0 text-muted">Color</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(item?.permit_vehicle, 'style') && (
                            <th className="fw-bold px-0 text-muted">Style</th>
                        )}
                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(item?.permit_vehicle, 'country') && (
                            <th className="fw-bold px-0 text-muted">Country</th>
                        )}
                        {shouldShowVehicleColumn(item?.permit_vehicle, 'state_code') ? <th className="fw-bold px-0 text-muted ">State</th> : null}
                        {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(item?.permit_vehicle, 'vehicle_number') && (
                            <th className="fw-bold px-0 text-muted">VIN</th>
                        )}
                    </tr>
                </thead>

                <tbody>
                    {renderVehicleRow(item?.permit_vehicle?.[0], 0, item?.permit_vehicle)}
                </tbody>

                <tbody className="collapse" style={{ height: '300px' }} id={`vehicleCollapse-${item?.id}`}>
                    {(item?.permit_vehicle?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, item?.permit_vehicle))}
                </tbody>
            </table>
        </div>
    }

    const formValidation = (validFields = []) => {
        if (!handleValidator(validator, validFields, forceUpdate)) {
            return false
        }

        const termsPermission =
            !isPermissionExist(accessPermissions, 'Display Terms & Conditions') ||
            (
                isPermissionExist(accessPermissions, 'Display Terms & Conditions') &&
                keyCardData?.userAcknowledge
            )

        const tcAcceptanceCondition =
            !isPermissionExist(accessPermissions, 'Display TC Acceptance') ||
            (
                isPermissionExist(accessPermissions, 'Display TC Acceptance') &&
                keyCardData?.tc_acceptance_signature
            )

        if (!termsPermission) {
            setFormError('permitAccount')
        }

        const finalCondition = (termsPermission && tcAcceptanceCondition)

        return finalCondition
    }

    const handleKeyCardChangeRequest = (item = {}) => {

        const tc_acceptance_date = keyCardData?.tc_acceptance_date ? moment(keyCardData?.tc_acceptance_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD')

        let formPostData = new FormData()    //formdata object
        formPostData.append('user_id', item?.user?.id)
        formPostData.append('permit_id', item?.id)
        formPostData.append('partner_id', item?.partner_id)
        formPostData.append('tc_acceptance_signature', keyCardData?.tc_acceptance_signature)
        formPostData.append('tc_acceptance_date', tc_acceptance_date)

        let filteredValidatorFieldKeys = excludeKeysFromValidator(validator, false, keyCardData, accessPermissions)
        let allValid = formValidation(filteredValidatorFieldKeys)

        // If valid, continue as before.
        return allValid ? dispatch(keycardReplacementRequestAction(formPostData)).then(() => {
            notify('success', 'Replacement request submitted successfully.')
            getPermitList()
            setShowKeyCardChangeModal(false)
        }).catch((err) => {
            console.log(err)
        }) : false
    }

    const keyCardDescription = () => {
        return <>
            <p>
                Please confirm that you would like to request a change to your assigned keycard.
            </p>
            <p className='text-muted small'>
                <i>
                    Note: Once the new card is activated, your existing keycard will no longer be valid. Please ensure that you wish to proceed.
                </i>
            </p>
            {(() => {
                // Use replacementDetails from keyCardModalRef if available
                const replacementDetails = keyCardModalRef?.current?.replacementDetails
                if (!replacementDetails) return null
                const {
                    replacement_price,
                    processing_fee,
                    tax_fee,
                    total_amount
                } = replacementDetails

                return (
                    <div>
                        <strong>Charges Breakdown:</strong>
                        <table className="table table-borderless table-sm mb-0 mt-2">
                            <tbody>
                                <tr>
                                    <td>Replacement Price</td>
                                    <td>
                                        {replacement_price !== undefined && replacement_price !== null
                                            ? `$${Number(replacement_price).toFixed(2)}`
                                            : '-'}
                                    </td>
                                </tr>
                                {Number(processing_fee) > 0 && (
                                    <tr>
                                        <td>Processing Fee</td>
                                        <td>
                                            {processing_fee !== undefined && processing_fee !== null
                                                ? `$${Number(processing_fee).toFixed(2)}`
                                                : '-'}
                                        </td>
                                    </tr>
                                )}
                                {Number(tax_fee) > 0 && (
                                    <tr>
                                        <td>Tax</td>
                                        <td>
                                            {tax_fee !== undefined && tax_fee !== null
                                                ? `$${Number(tax_fee).toFixed(2)}`
                                                : '-'}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td><strong>Total Amount</strong></td>
                                    <td>
                                        <strong>
                                            {total_amount !== undefined && total_amount !== null
                                                ? `$${Number(total_amount).toFixed(2)}`
                                                : '-'}
                                        </strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
            })()}
            <TCAcceptanceSection
                accessPermissions={accessPermissions}
                formData={keyCardData}
                setFormData={setKeyCardData}
                formError={formError == 'permitAccount'}
                partnerDetails={partnerDetails}
                validator={validator}
                showTerm={showTerm}
                setShowTerm={setTermShow}
                handleInputFieldsData={(e) => {
                    const { name, value } = e.target
                    setKeyCardData({ ...keyCardData, [name]: value })
                }}
            />
        </>
    }


    const handleResetData = () => {
        setKeyCardData({
            userAcknowledge: false,
            tc_acceptance_signature: '',
            tc_acceptance_date: new Date(),
            facility_id: ''
        })
    }


    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-2">
                    <h4 className="fw-bold m-0">Permit Account</h4>
                    {isPermissionExist(accessPermissions, 'Display Terms & Conditions') ? <p className='m-0'><i className='fa fa-link me-2'></i><a href='javascript:;' onClick={handleModalTerm} className=''><b>Terms & Conditions</b></a></p> : null}

                    {/* <Link to='/'>
                    <button className="btn btn-success ms-auto"><i className="fa fa-plus"></i> Add</button>
                </Link> */}
                </div>
                {permitListData?.length > 0 ?
                    <ul className="permitList d-flex flex-column gap-2">
                        {permitListData?.map((item, index) => {
                            if (item == null) return null

                            let permitUsagelist = []
                            let permitUsageRemaning = item?.remaining_usage ? Number(item?.remaining_usage) : null

                            // let permitUsage=item?.ticket_count ? Number(item?.ticket_count) :null

                            let totalUsage = item?.total_usage ? Number(item?.total_usage) : null

                            if (totalUsage && totalUsage > 0) {
                                for (let i = 1; i <= totalUsage; i++) {
                                    permitUsagelist.push(<li key={i} className={permitUsageRemaning >= i ? 'active' : 'inactive'}></li>)
                                }
                            }




                            return (
                                <li
                                    className={`TicketCardStyle d-flex py-2 flex-column gap-1 mb-2 ${isActivePermit(item) ? 'active border-success' : item?.cancelled_at != null ? 'inactive border-danger' : 'inactive border-secondary'}`}
                                    key={index} >
                                    {/* title box started here */}
                                    <div className='d-flex justify-content-sm-between ' >
                                        <div id='titles' className='d-flex gap-2'>
                                            <i className={`fa fa-parking fa-3x   ${isActivePermit(item) ? 'text-success ' : item?.cancelled_at != null ? 'text-danger' : 'text-secondary'}`}></i>
                                            <div className='d-flex flex-column align-items-start gap-1' >
                                                <h5 style={{ lineHeight: '1.05' }} className={`mb-0 fw-bold d-block   ${isActivePermit(item) ? 'text-success ' : item?.cancelled_at != null ? 'text-danger' : 'text-secondary'} `}>Permit No #{item?.account_number}</h5>

                                                <div className='d-flex gap-1'>
                                                    <span className={`badge fw-normal rounded-pill ${isActivePermit(item) ? 'text-bg-success' : item?.cancelled_at != null ? 'text-bg-danger' : 'text-bg-secondary'}`}> {isActivePermit(item) ? 'Active' : item?.cancelled_at != null ? 'Cancelled' : (item.is_expired == 1) ? 'Expired' : 'In-Active'} </span>


                                                    {isActivePermit(item) ? <button
                                                        className='btn d-flex gap-1 aling-items-center  p-0 small btn-sm link'
                                                        type='button'
                                                        disabled={downloadQR}

                                                        onClick={() => downloadPermitQr(item?.id, item?.account_number)}
                                                    >
                                                        Download QR
                                                        <i className='fa fa-download p-0'></i>
                                                        {downloadQR == item?.id ? <span className='ms-1'><Circles
                                                            height="9"
                                                            width="9"
                                                            color="#000"
                                                            ariaLabel="circles-loading"
                                                            visible={true}
                                                        /></span> : null}
                                                    </button>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-block text-end'>

                                            <div className='small text-secondary' style={{ marginBottom: '0.25rem' }}>{(item?.cancelled_at != null) ? <span>Cancelled at - {item?.cancelled_at ? moment(item?.cancelled_at, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY') : null} </span> : null}</div>
                                            <div style={{ marginBottom: '0.25rem' }}> {(item?.cancelled_at != null && !moment(new Date()).isAfter(moment(item?.grace_end_date), 'day') && !moment(item?.cancelled_at).isAfter(moment(item?.grace_end_date), 'day')) ? 'The Permit is Active and will be cancelled from the next Term.' : null}</div>

                                            {((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && < div className="d-flex gap-0 aling-items-center justify-content-end">
                                                <div className='form-check form-switch'>
                                                    <input disabled={item?.is_expired == 0 && item?.cancelled_at == null && item?.stop_renew_consent == '0' ? false : true} type="checkbox" id={`${'cancelAutoRenewToggle' + item.id}`} onClick={() => item?.is_expired == 0 && item?.cancelled_at == null && item?.stop_renew_consent == '0' ? cancelPermitRenew(item, index) : null} checked={item?.user_consent == '1' ? true : false} className='form-check-input' style={{ marginRight: '0.25rem' }} />

                                                </div>
                                                <small htmlFor='cancelAutoRenewToggle' className='small me-2' style={{ lineHeight: '1.6' }}  >{item?.user_consent == '1' ? 'Disable' : 'Enable'} Auto Renew </small>

                                                {isPermissionExist(accessPermissions, 'Cancel Permit') ? <a type='button' onClick={() => showPermitModal(item)} className={`btn btn-sm small p-0 text-danger  ${(item?.permit_renew_pay == '1' || item?.cancelled_at == null) ? '' : ' disabled'}`} >  Cancel Permit</a> : ''}
                                            </div>}


                                        </div>
                                    </div>
                                    {/*  title box ends */}

                                    <div className='border border-dashed my-1 d-block w-100'></div>

                                    <div className='row justify-content-between align-items-center'>
                                        <div className='col-lg-4'>
                                            <div className="d-flex  gap-2" style={{ padding: '0.25rem 0' }}>
                                                <i className='fa  fa-ticket'></i>
                                                <div className='d-flex flex-column'  >
                                                    {isActivePermit(item) && (
                                                        <h6 className='mb-0 fw-bold' style={{ fontSize: '0.8rem', lineHeight: '0.8' }}>
                                                            {(isPermissionExist(accessPermissions, 'Hide Facility') && !(item?.permitServices?.some(service => service?.display_facility == 1))) ? null : item?.facility?.full_name ? `${item?.facility?.full_name} -` : ''}
                                                        </h6>
                                                    )}
                                                    <small className='text-muted'>{item?.permit_type_name} {item?.permit_rate?.rate_description?.is_hide_validity == '0' && item?.permit_rate?.rate_description?.description ? `(${item?.permit_rate?.rate_description?.description})` : ''}</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-4'>
                                            <div className='dateRangeSelector'>
                                                <div className='d-flex w-full'>
                                                    <div className='leftBlock w-full justify-content-start gap-2 p-1 d-flex align-items-center'>
                                                        <i className='fa fa-calendar text-success'></i>
                                                        <div className='gap-1 d-flex flex-column' >
                                                            <small style={{ fontSize: '80%' }}>Start at</small>
                                                            <h6 className='fw-bold small m-0 text-black' >{moment(item?.desired_start_date).format('MM/DD/YYYY')}</h6>
                                                        </div>
                                                    </div>
                                                    <div className='rightBlock w-full border-start p-05 justify-content-end text-end gap-2 d-flex align-items-center'>
                                                        <div className='gap-1 d-flex flex-column'>
                                                            <small style={{ fontSize: '80%' }}>End at</small>
                                                            <h6 className='fw-bold small m-0 text-black' >{moment(item?.desired_end_date).format('MM/DD/YYYY')}</h6>
                                                        </div>
                                                        <i className='fa fa-calendar text-danger'></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {(item?.permit_rate?.rate_description?.is_hide_validity == '0' && item?.permit_rate?.permit_rate_criteria_mapping?.length > 0) && perkingParkingTimeAccount(item?.permit_rate, true) ? (
                                            <div className='col-lg-4 text-sm-end'>
                                                {perkingParkingTimeAccount(item?.permit_rate, true)}
                                            </div>
                                        ) : null}


                                        {!(item?.keycard_mappings && (item?.keycard_mappings.length > 0)) && item?.hid_card_number && item?.facility?.facility_configuration?.hid_card_enabled == '1' && (
                                            <div className='col-lg-4 '>
                                                <p style={{ marginBottom: '0.25rem' }}><b className='text-muted small'>Prox Card Id: </b><span className='text-black small'>{item?.hid_card_number}</span></p>
                                            </div>
                                        )}
                                        {item?.user_type_id && <div className='col-lg-4 '>
                                            <p style={{ marginBottom: '0.25rem' }}><b className='text-muted small'>Student/Staff/Faculty ID: </b><span className='text-black small'>{item?.user_type_id}</span></p>
                                        </div>}
                                    </div>

                                    {employerDetailsSection(item?.employer_details, true)}

                                    {/* uploaded documents */}
                                    {item?.permit_doc?.length > 0 ? (
                                        <div className='bg-light horizontal-gradient my-1 p-1 rounded-3'>
                                            <div className='d-flex align-items-sm-center gap-1 flex-column flex-sm-row'>
                                                <h5 className='fw-bold m-0'  ><i className='fa fa-file me-1'></i>Uploaded Document - </h5>
                                                {item?.permit_doc?.length > 0 ?
                                                    item?.permit_doc?.map((item, index) => {
                                                        return (
                                                            <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0' style={{ fontSize: '95%' }}> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>
                                                        )
                                                    })
                                                    : <div className='col'>
                                                        <span className='fontsize85'>
                                                            N/A
                                                        </span>
                                                    </div>}
                                            </div>
                                        </div>
                                    ) : null}

                                    {/* permit service */}
                                    {(item?.permitServices?.length > 0 || (isPermissionExist(accessPermissions, 'Permit Category') && item?.permit_rate?.is_hide_carpool_toogle == '0')) ? (
                                        <div className='d-flex flex-sm-row border-top py-1 flex-column justify-content-between'>
                                            <div className='left'>
                                                <b>Permit Services(s)</b>
                                                {item?.permitServices?.length > 0 && item?.permitServices?.map((v, i) => {
                                                    if (v?.permit_service_name != 'Select All Access') {
                                                        return (
                                                            <div key={i} className='d-flex px-0 w-full align-items-center justify-content-between'>
                                                                <div className='text-muted text-capitalize' style={{ fontSize: '90%' }}>
                                                                    {v?.permit_service_name} {(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                            {isPermissionExist(accessPermissions, 'Permit Category') && item?.permit_rate?.is_hide_carpool_toogle == '0' ? (
                                                <div className='form-check form-switch d-flex align-items-center gap-2' style={{ marginLeft: '0.25rem' }}>
                                                    <input disabled={item?.is_expired == 0 && item?.cancelled_at == null ? false : true} type="checkbox" id='addServiceToggle' checked={item?.permitServiceCarpool == '1' ? true : false} onClick={() => AddServicePermit(item, index)} className='form-check-input small' style={{ marginRight: '0.25rem', marginTop: '-2px' }} />
                                                    <small htmlFor='addServiceToggle' className='form-check-label small fw-normal' style={{ fontSize: '90%', lineHeight: '1.5' }}>Carpool Access-$0.00</small>
                                                    <span className="popoverSectionNew position-relative ms-05">
                                                        <div className='small popoverContent position-absolute shadow-sm bg-white p-1 border' style={{ fontSize: '85%' }}>Please use this toggle to enable/disable Carpool access</div>
                                                        <i className="fa fa-question-circle"></i>
                                                    </span>
                                                </div>
                                            ) : ''}
                                        </div>
                                    ) : ''}

                                    {/* vehicle table section */}
                                    {item?.permit_vehicle && item?.permit_vehicle?.length > 0 &&
                                        <div className='my-1'>
                                            <div className='border border-dashed my-1 d-block w-100'></div>
                                            <div className="d-flex align-items-center mb-1 justify-content-between mb-2">
                                                <b className='text-dark' style={{ marginRight: '0.5em' }}>Vehicle(s)</b>
                                                {item?.permit_vehicle?.length > 1 && (
                                                    <div className='d-flex align-items-center gap-1' style={{ gap: '0.25rem', marginLeft: '0.5rem' }}>
                                                        <span className='fw-bold text-primary small' style={{ fontSize: '0.92em' }}>
                                                            {`${item?.permit_vehicle?.length} ${item?.permit_vehicle?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
                                                        </span>
                                                        <button
                                                            className='btn btn-default btn-sm p-05'
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#vehicleCollapse-${item?.id}`}
                                                            aria-expanded={displayVehicle}
                                                            aria-controls={`vehicleCollapse-${item?.id}`}
                                                            onClick={handleshowVehicle}
                                                            style={{ padding: '0.08rem 0.35rem', fontSize: '0.9em', lineHeight: '1.1', minHeight: '1.5em' }}
                                                        >
                                                            {displayVehicle ? 'Hide All' : 'View All'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            {isMobile ? (
                                                <div>
                                                    <div style={{ marginBottom: '0.15rem' }}>
                                                        {mobileViewVehicleSection(item?.permit_vehicle?.[0], 0, item?.permit_vehicle)}
                                                    </div>
                                                    <div className="collapse" style={{ height: '110px', lineHeight: '1.15' }} id={`vehicleCollapse-${item?.id}`}>
                                                        {(item?.permit_vehicle?.slice(1) || []).map((v, i) =>
                                                            <div key={i} style={{ marginBottom: '0.1rem' }}>
                                                                {mobileViewVehicleSection(v, i + 1, item?.permit_vehicle)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{ fontSize: '0.92em', lineHeight: '1.2', marginTop: '-0.35rem' }}>
                                                    {deskTopViewVehicleSection(item)}
                                                </div>
                                            )}
                                        </div>
                                    }

                                    {/* driver */}
                                    {item?.authorized_driver && item?.authorized_driver.length > 0 && (
                                        <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                            <div className='border border-dashed my-1 d-block w-100'></div>
                                            <table className='table mt-1' cellSpacing="0" cellPadding="0" style={{ fontSize: '0.92em', lineHeight: '1.2', marginBottom: 0 }}>
                                                <thead>
                                                    <tr>
                                                        <th className='text-muted border ps-1 small' style={{ fontWeight: 500, padding: '0.35em' }}>Driver Name:</th>
                                                        <th className='text-muted border ps-1 small' style={{ fontWeight: 500, padding: '0.35em' }}>Document:</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item?.authorized_driver?.map((v, i) => (
                                                        <tr key={i} style={{ verticalAlign: 'middle', lineHeight: '1.1' }}>
                                                            <td className='small border ps-1' style={{ padding: '0.35em' }}>{v?.driver_name}</td>
                                                            <td className='small border ps-1' style={{ padding: '0.35em' }}>
                                                                {v?.url ? <a className="small" href={v?.url} target='_blank' rel="noreferrer" style={{ fontSize: 'inherit' }}>View</a> : <span>-</span>}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    <div className='row d-none'>
                                        <div className='col-sm mb-sm-0 mb-1'>
                                            <table cellSpacing="0px" cellPadding="0" style={{ fontSize: '90%' }}>
                                                <tr>
                                                    <th className='text-muted d-none'>Driver License No.:</th><td className='px-1'></td> <td className='text-end'>{item?.license_number}</td>
                                                </tr>
                                                {item?.user?.resident_status ? <tr>
                                                    <th colSpan="3" className='text-muted d-none'><span className="badge bg-success"> {item?.user?.resident_status}</span></th>
                                                </tr> : <span className='text-muted d-none'>NA</span>}
                                            </table>
                                        </div>
                                        {item?.permit_vehicle && (
                                            <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                                <style>
                                                    {`
                                                        .vehicle-table th,
                                                        .vehicle-table td {
                                                            max-width: 120px;
                                                            white-space: nowrap;
                                                            overflow: hidden;
                                                            text-overflow: ellipsis;
                                                            vertical-align: middle;
                                                        }
                                                        @media (max-width: 576px) {
                                                            .vehicle-table th,
                                                            .vehicle-table td {
                                                                max-width: 80px;
                                                            }
                                                        }
                                                        .vehicle-collapse {
                                                            transition: max-height 0.48s cubic-bezier(0.4, 0, 0.2, 1);
                                                            overflow: hidden;
                                                            display: block;
                                                        }
                                                    `}
                                                </style>
                                                <table className='vehicle-table table border mt-1' style={{ fontSize: '90%', tableLayout: 'fixed', width: '100%' }}>
                                                    <thead className='border-bottom bg-light'>
                                                        <tr>
                                                            {item?.permit_vehicle[0]?.vehicle?.license_plate_number && (
                                                                <th className='p-1 border-e text-muted'>License Plate</th>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.color && (
                                                                <th className='p-1 border-e text-muted'>Color</th>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.make && (
                                                                <th className='p-1 border-e text-muted'>Make</th>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.model && (
                                                                <th className='p-1 text-muted'>Model</th>
                                                            )}
                                                            {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? (
                                                                <th className='p-1 lh-4 text-muted'>Vehicle Type</th>
                                                            ) : null}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            {item?.permit_vehicle[0]?.vehicle?.license_plate_number && (
                                                                <td className='p-1 border-e'>
                                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number}
                                                                </td>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.color && (
                                                                <td className='p-1 border-e'>
                                                                    {item?.permit_vehicle[0]?.vehicle?.color}
                                                                </td>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.make && (
                                                                <td className='p-1 border-e'>
                                                                    {item?.permit_vehicle[0]?.vehicle?.make}
                                                                </td>
                                                            )}
                                                            {item?.permit_vehicle[0]?.vehicle?.model && (
                                                                <td className='p-1'>{item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                            )}
                                                            {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? (
                                                                <td className='p-1 lh-4'>
                                                                    {item?.permit_vehicle[0]?.vehicle?.vehicle_type ? item?.permit_vehicle[0]?.vehicle?.vehicle_type : '-'}
                                                                </td>
                                                            ) : null}
                                                        </tr>
                                                    </tbody>
                                                    {item?.permit_vehicle?.length > 1 && (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="100%">
                                                                    <div
                                                                        className="vehicle-collapse"
                                                                        style={{
                                                                            maxHeight: displayVehicle ? `${item?.permit_vehicle?.length * 48}px` : '0px',
                                                                        }}
                                                                    >
                                                                        <table style={{ width: '100%' }}>
                                                                            <tbody>
                                                                                {item?.permit_vehicle
                                                                                    .slice(1)
                                                                                    .map((veh, vidx) => (
                                                                                        <tr key={vidx + 1}>
                                                                                            {item?.permit_vehicle[0]?.vehicle?.license_plate_number && (
                                                                                                <td className='p-1 border-e'>
                                                                                                    {veh?.vehicle?.license_plate_number || '-'}
                                                                                                </td>
                                                                                            )}
                                                                                            {item?.permit_vehicle[0]?.vehicle?.color && (
                                                                                                <td className='p-1 border-e'>
                                                                                                    {veh?.vehicle?.color || '-'}
                                                                                                </td>
                                                                                            )}
                                                                                            {item?.permit_vehicle[0]?.vehicle?.make && (
                                                                                                <td className='p-1 border-e'>
                                                                                                    {veh?.vehicle?.make || '-'}
                                                                                                </td>
                                                                                            )}
                                                                                            {item?.permit_vehicle[0]?.vehicle?.model && (
                                                                                                <td className='p-1'>
                                                                                                    {veh?.vehicle?.model || '-'}
                                                                                                </td>
                                                                                            )}
                                                                                            {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? (
                                                                                                <td className='p-1 lh-4'>
                                                                                                    {veh?.vehicle?.vehicle_type ? veh?.vehicle?.vehicle_type : '-'}
                                                                                                </td>
                                                                                            ) : null}
                                                                                        </tr>
                                                                                    ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                                {item?.permit_vehicle?.length > 1 ? (
                                                    <span
                                                        className='fw-bold text-primary text-decoration-underline cursor'
                                                        onClick={() => handleshowVehicle()}
                                                        style={{ userSelect: 'none', cursor: 'pointer' }}
                                                    >
                                                        {displayVehicle ? 'Hide All' : 'View All'}
                                                    </span>
                                                ) : null}
                                            </div>
                                        )}
                                    </div>

                                    {/*  transtion card detils */}
                                    <div className='border border-dashed my-1 d-block w-100'></div>

                                    {item?.business_id && item?.business_id != '' ? null : <div>   <b className='text-dark' style={{ marginRight: '0.5em' }}>Payment Information</b> <div className='row g-3 row-cols-4 justify-content-between align-items-center' >
                                        <div className='col-auto'>
                                            <small className='fw-bold text-muted '>Amount paid</small>
                                            <p className='m-0' style={{ fontSize: '90%' }}> ${item?.permit_final_amount}</p>
                                        </div>
                                        <div className='col-auto'>
                                            <small className='fw-bold text-muted '>Transaction Number</small>
                                            <p className='m-0' style={{ fontSize: '90%' }}>{item?.transaction?.anet_trans_id ? item?.transaction?.anet_trans_id : '-'}</p>
                                        </div>
                                        <div className='col-auto'>
                                            <small className='fw-bold text-muted '>Card details</small>
                                            {Number(item?.permit_final_amount) > 0 ? (
                                                item?.transaction?.method === 'APL' ? (
                                                    <span className='badge bg-dark small rounded-5 fw-light'>
                                                        <span className='d-flex align-items-center gap-05'>
                                                            Paid by: <i className='fa-brands fa-apple-pay fs-5'></i>
                                                        </span>
                                                    </span>
                                                ) : item?.transaction?.method === 'GPAY' ? (
                                                    <span className='badge bg-dark small rounded-5 fw-light'>
                                                        <span className='d-flex align-items-center gap-05'>
                                                            Paid by: <i className='fa-brands fa-google-pay fs-5'></i>
                                                        </span>
                                                    </span>
                                                ) : (
                                                    <p className='m-0 ' style={{ fontSize: '90%' }}>
                                                        Ending With - {item?.paymentDetails?.card_last_four ? item?.paymentDetails?.card_last_four : item?.transaction?.payment_last_four ? item?.transaction?.payment_last_four : '-'}
                                                        &nbsp;&nbsp;|&nbsp;&nbsp;Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0, 2) + '/' + item?.paymentDetails?.expiry?.slice(2, 4) : item?.transaction?.expiration ? item?.transaction?.expiration?.slice(0, 2) + '/' + item?.transaction?.expiration?.slice(2, 4) : '-'}
                                                    </p>
                                                )
                                            ) : '-'}
                                        </div>
                                        <div className='col-auto'>
                                            <small className='fw-bold text-muted  d-block'>Payment Date</small>
                                            {Number(item?.permit_final_amount) > 0 ? <p className='m-0' style={{ fontSize: '90%' }}> {moment(item?.transaction?.created_at).format('MM/DD/YYYY hh:mm a')}</p> : '-'}
                                        </div>
                                    </div>
                                    </div>}
                                    {(item?.reserved_space_number && item?.reserved_space_number != '') ? <div className='row g-05 row-cols-1 row-cols-sm-4' >
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'>Preferred Reserved Space Number:</small>
                                            <p className='m-0' style={{ fontSize: '90%' }}>{item?.reserved_space_number}</p>
                                        </div>
                                    </div> : null}
                                    {(item?.is_passwallet_active === true ||
                                        (item?.account_number && APICONFIG.getGooglePermitPassDownload && APICONFIG.getapplePermitPassDownload)) ? (
                                        <div className='row justify-content-end'>
                                            <div className='mt-1 col-sm-4'>
                                                <PassWalletButtons
                                                    ticketId={item?.account_number}
                                                    googleWalletApi={APICONFIG.getGooglePermitPassDownload}
                                                    appleWalletApi={APICONFIG.getapplePermitPassDownload}
                                                    notify={notify}
                                                    partnerDetails={partnerDetails}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    {/*  card details ends */}

                                    {(isPermissionExist(accessPermissions, 'Display Permit Pay Now') && item?.permit_renew_pay == '1' && Number(item?.total_permit_amount) > 0 && item?.cancelled_at == null) ?
                                        <>
                                            <div className='border border-dashed my-2 d-block w-100'></div>
                                            <div className='row g-sm-2 gap-2 align-items-end justicy-content-between' style={{ marginBottom: 0 }}>
                                                <div className='col-auto flex-grow-1 '>
                                                    <b className=' '>Bill Cycle</b>
                                                    <p className='m-0'>{item?.billing_start_date ? moment(item?.billing_start_date).format(dateDisplayFormat) : ''} - {item?.billing_end_date ? moment(item?.billing_end_date).format(dateDisplayFormat) : ''}</p>
                                                </div>
                                                <div className='col-auto pr-md-2 border-sm-end'>
                                                    <b>Amount Due</b>
                                                    <p className='fw-bold text-primary m-0'>
                                                        ${item?.total_permit_amount}
                                                    </p>
                                                </div>
                                                <div className='col-auto'><button className="btn btn-success" onClick={() => handlePaymentModalOpen(item)} style={{ padding: '0.25rem 0.75rem', fontSize: '90%' }}>Pay Now</button></div>
                                            </div>
                                        </>
                                        : ''}
                                    <div className='card-footer p-1 d-none'>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-sm-4 text-end order-sm-1 order-4'>
                                                {item?.transaction?.total && <p className='mb-0'><b className=' fw-bold'>Paid: </b> ${item?.transaction?.total}</p>}
                                            </div>
                                            <div className='col-sm-4'>
                                                <small><b className='fw-bold'>Amount Due:</b> <br className='d-block d-sm-none' />${item?.transaction?.total}</small>
                                            </div>
                                            <div className='col-sm-4'>
                                                <small><b className='t fw-bold'>Autopay Enabled</b> - <br className='d-block d-sm-none' />{item?.user_consent ? item?.user_consent == '1' ? 'Yes' : 'No' : 'Yes'}</small>
                                            </div>
                                        </div>
                                        {isPermissionExist(accessPermissions, 'Download Permit QR') ? ((item?.is_expired == 0 && item?.cancelled_at == null) || (item?.user_consent === '1')) && <div className='d-flex justify-content-between'>
                                            {(item?.is_expired == 0 && item?.cancelled_at == null) ? <span>
                                                <button
                                                    className='mt-1 btn btn-primary btn-sm'
                                                    type='button'
                                                    disabled={downloadQR}
                                                    style={{ padding: '0.25rem 0.5rem' }}
                                                    onClick={() => downloadPermitQr(item?.id, item?.account_number)}
                                                >
                                                    Download QR
                                                </button>
                                            </span> : <span></span>}
                                        </div> : null}
                                    </div>

                                    {item?.permit_ticket && item?.permit_ticket.length > 0 ?
                                        <span className='fw-bold text-primary text-decoration-underline ms-1' onClick={() => handleshowCheckIn()} style={{ fontSize: '90%' }}>
                                            {displayCheckIn ? 'Hide Check-In List' : 'Show Check-In List'}
                                        </span>
                                        : ''}
                                    <div className="card-body table-responsive p-0">
                                        {(displayCheckIn && item?.permit_ticket.length > 0) ?
                                            <table className="table table-borderless table-sm mb-0" style={{ fontSize: '90%' }}>
                                                <thead>
                                                    <tr className='text-muted'>
                                                        <th scope="col" className='tableLicensePlate px-0'>Ticket #</th>
                                                        <th scope="col" className='px-0'>License Plate</th>
                                                        <th scope="col" className='px-0'>Check-In At</th>
                                                        <th scope="col" className='px-0'>Check-Out At</th>
                                                        <th scope='col' className='px-0'>Amount Paid</th>
                                                        <th scope='col' className='px-0'>Reference ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr key={index}>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.ticket_number}</td>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.license_plate}</td>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.checkin_time ? moment(item?.permit_ticket[0]?.checkin_time).format('MM/DD/YYYY') + ', ' + moment(item?.permit_ticket[0]?.checkin_time).format('h:mm A') : '-'}</td>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.checkout_datetime ? moment(item?.permit_ticket[0]?.checkout_datetime).format('MM/DD/YYYY') + ', ' + moment(item?.permit_ticket[0]?.checkout_datetime).format('h:mm A') : '-'}</td>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.total}</td>
                                                        <td className='px-0'>{item?.permit_ticket[0]?.permit_request_id}</td>
                                                    </tr>
                                                </tbody>
                                            </table> : ''}
                                    </div>
                                    {/* key card section start */}
                                    {item?.keycard_mappings && (item?.keycard_mappings.length > 0) && (
                                        <div className="card-body table-responsive p-0">
                                            <div className='border border-dashed my-1 d-block w-100'></div>
                                            <div className="d-flex align-items-center justify-content-between mb-1 flex-wrap">
                                                <span className='fw-bold text-primary mb-1'>
                                                    {'Keycard Details'}
                                                </span>
                                                {(() => {
                                                    const atLeastOneActive = item?.keycard_mappings?.some(el => el?.status_text === 'Active')
                                                    const hasPendingReplacement = item?.keycard_mappings?.some(el => el?.status_text === 'Pending')
                                                    const disableButton = !atLeastOneActive || hasPendingReplacement

                                                    return (
                                                        <button
                                                            type="button"
                                                            className='btn btn-primary btn-sm ms-2'
                                                            style={{
                                                                cursor: !disableButton ? 'pointer' : 'not-allowed',
                                                                color: !disableButton ? undefined : 'grey',
                                                                opacity: !disableButton ? 1 : 0.7,
                                                                fontWeight: 500,
                                                                borderColor: !disableButton ? undefined : 'grey',
                                                                padding: '0.25rem 0.5rem'
                                                            }}
                                                            onClick={() => {
                                                                if (!disableButton) {
                                                                    const activeKeycard = (item?.keycard_mappings || [])?.find(el => el?.status_text === 'Active')
                                                                    let payload = {
                                                                        'keycard_id': activeKeycard?.keycard_id,
                                                                        'facility_id': item?.facility_id
                                                                    }
                                                                    keyCardData['facility_id'] = item?.facility_id
                                                                    setKeyCardData({ ...keyCardData })
                                                                    dispatch(keycardReplacementDetails(payload)).then((res) => {
                                                                        keyCardModalRef.current = {
                                                                            ...keyCardModalRef.current,
                                                                            replacementDetails: res
                                                                        }
                                                                        keyCardModalRef.current = {
                                                                            ...keyCardModalRef.current,
                                                                            currentPermitItem: item
                                                                        }
                                                                        setShowKeyCardChangeModal(true)
                                                                    })
                                                                }
                                                            }}
                                                        >
                                                            Request Keycard Replacement
                                                        </button>
                                                    )
                                                })()}
                                            </div>
                                            <table className="table table-bordered table-sm mb-0" style={{ fontSize: '90%' }}>
                                                <thead>
                                                    <tr className='text-muted'>
                                                        <th scope="col" className='tableLicensePlate'>Request Date</th>
                                                        <th scope="col" className='tableLicensePlate'>Keycard Number</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item?.keycard_mappings?.map((el, index) => {
                                                        return <tr key={index}>
                                                            <td>{el?.request_date ? moment(el?.request_date).format('MM/DD/YYYY hh:mm a') : '-'}</td>
                                                            <td>{el?.keycard_number || '-'}</td>
                                                            <td>{el?.total_amount ? el?.total_amount : '-'}</td>
                                                            <td><span className={`${keycardStatus(el?.status_text)}`}>{el?.status_text || 'N/A'}</span></td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                            <ConfirmationModal
                                                title='Keycard Replacement Request'
                                                showModal={showKeyCardChangeModal}
                                                setShowModal={setShowKeyCardChangeModal}
                                                dispatch={dispatch}
                                                notify={notify}
                                                description={keyCardDescription()}
                                                resetData={handleResetData}
                                                handleDispatchAction={() => {
                                                    if (keyCardModalRef?.current?.currentPermitItem) {
                                                        return handleKeyCardChangeRequest(keyCardModalRef?.current?.currentPermitItem)
                                                    }
                                                }}
                                            />
                                        </div>
                                    )}

                                    {/* key card section end */}

                                    {/*  permiit uses section */}
                                    {(permitUsagelist?.length > 0) && !isPermissionExist(accessPermissions, 'Get Permit By Email') ? <>
                                        <div className='border border-dashed my-1 d-block w-100'></div>
                                        <h6 className="fw-bold text-secondary" style={{ marginBottom: '0.25rem', fontSize: '1rem' }}>Remaining Usages</h6>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <ul className="availableSections" style={{ flexWrap: 'wrap', marginBottom: '0.25rem' }}>
                                                {permitUsagelist}
                                            </ul>
                                            <p className="m-0" style={{ fontSize: '90%' }}>
                                                <b>{permitUsageRemaning ? permitUsageRemaning : '0'}</b> out of <b className="text-success">{totalUsage ? totalUsage : '0'}</b> available
                                            </p>
                                        </div>
                                    </> : null}

                                    <ModalTerm partnerDetails={partnerDetails} facilityId={item?.facility?.id} setShow={setTermShow} show={showTerm} />
                                </li>
                            )
                        })}
                    </ul> : renderNoResults(displayError)}
                <AddCardPaymentModal 
                    isModalOpen={isModalOpen} 
                    hanndleCancel={hanndleCancel} 
                    cardList={cardList} 
                    setPayload={setPayload} 
                    setCardList={setCardList} 
                    setCardFormVisible={setCardFormVisible} 
                    isCardFormVisible={isCardFormVisible} 
                    setModal={setModal} 
                    handleSubmit={handleSubmit} 
                    payload={payload} 
                    modalName='Add Payment' 
                    isLoading={isLoading} 
                    handleCardChange={handleCardChange} 
                    handleExpiryChange={handleExpiryChange} 
                    handleCardSelectChange={handleCardSelectChange} 
                    expiry={expiry} 
                    cardExpiryMessage={cardExpiryMessage} 
                    card={card} 
                    errorMessage={errorMessagePay} 
                    error={error} 
                    setErrorMessage={setErrorMessagePay} 
                    setError={setError} 
                    setCard={setCard} 
                    setExpiry={setExpiry} 
                    handleInputFieldsData={handleInputFieldsData} 
                    partnerDetails={partnerDetails} 
                    isFiservGateway={isFiservGateway}
                    facilityDetails={facilityDetails}
                    tokenRef={tokenRef}
                    iframeErrorMsg={iframeErrorMsg}
                    setIframeErrorMsg={setIframeErrorMsg}
                    cardToken={cardToken}
                    setCardToken={setCardToken}
                />
                <ConfermationModal
                    setConfermationModal={setCancelModal}
                    confermationModal={cancelModal}
                    isLoading={isCancelLoading}
                    confermationHeading="Cancel Permit"
                    confermationMessage="Are you sure you want to cancel this permit?"
                    warning={buyoutType ? 'A cancellation charge of $75 is deducted from your card, and your credit card will not be charged 1st of next month.' : ''}
                    buttonLable="Cancel Permit"
                    handleDelete={cancelPermit}
                />
            </div>
    )
}

PermitAccount.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,

}

PermitAccount.defaulProps = {
    dispatch: noop,
    loader: false,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,

}

function mapStateToProps({ permitListReducer, PartnerReducer }) {
    return {
        loader: permitListReducer?.loader,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(PermitAccount)